import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';

import { Schedule, User, HelperMyRadiant } from '@providers/index';
import { FormSchedulePage, DetailSchedulePage } from '../';

@Component({
  selector: 'page-schedule',
  templateUrl: 'page.html'
})
export class SchedulePage {

  listSchedule : any ;
  project      : any = {};
  loading      : any;
  can_edit           =false;
  can_delete = false;

  constructor(
    public navCtrl    : NavController,
    public navParams  : NavParams,
    private toastCtrl : ToastController,
    public loadingCtrl: LoadingController,
    public scheduleApi: Schedule,
    public userApi    : User,
    public helper     : HelperMyRadiant 
  ) {
    this.project = this.navParams.get('project');

    if (this.userApi.akses.delete_schedule_project) {
      this.can_delete = true;
    }

    if(this.userApi.akses.edit_project_group_data=='branch'){
      if(this.project.branch_id == this.userApi.group.user_data){
        this.can_edit=true;
      }
    }else if(this.userApi.akses.edit_project_group_data=='all'){
      this.can_edit = true;
    }else if(this.userApi.akses.edit_project_group_data=='mine'){
      if(this.project.created_by == this.userApi.data.employee_id){
        this.can_edit=true;
      }
    }
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params = {
      project_id : this.project.id
    }
    this.scheduleApi.get(params).subscribe((resp:any) => {
      this.listSchedule = resp.data;
      this.loading.dismiss();
    });
  }

  add() {
    this.navCtrl.push(FormSchedulePage, {
      project: this.project
    });
  }

  edit(rec) {
    this.navCtrl.push(FormSchedulePage, {
      project: this.project,
      rec:rec
    });
  }

  detail(rec) {
    this.navCtrl.push(DetailSchedulePage, {
      project: this.project,
      rec:rec
    });
  }

  deleteSchedule(item) {
    let params = {
      id : item.id,
      tender_id : item.tender_id
    }

    let me = this,
      optionsSwal = {
      title: "Are you sure ?",   
      desc:"Once you delete schedule, you cant't undo it. ",   
      icon: "",
      dangerMode: false,
      btnCancel: "Cancel",
      btnConfirm: "Delete",
    }
    this.helper.presentSwalConfirmation(optionsSwal, () => {
      me.loading = me.helper.showLoading("Please Wait...");
      me.scheduleApi.delete(params).subscribe((resp:any) => {        
        if (resp.success) {       
          try {
            me.loading.dismiss();
          } catch (error) {
          }
          me.helper.presentToast(resp.msg);
          me.getList();
        } else {
          me.helper.presentToast(resp.msg);
        }
      }, (err) => {
        try {
          me.loading.dismiss();
        } catch (error) {

        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/schedule/page.ts